export default __webpack_public_path__ + "static/media/HappyBirthday_22.b3d36eaf.png";